const API_BASE = 'https://api.acetn.org/api';

export default API_BASE;